import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';
import { IId } from 'interfaces/common/common';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteConfigurationTemplate } from '@api/configurationTemplates';

import { IPartialOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONFIGURATION_TEMPLATES, CONFIGURATION_TEMPLATES_UPDATE_NOTES  } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConfigurationTemplateDeleteReturned {
	isLoadingDeleteTemplate: boolean;
	deleteTemplate: UseMutateFunction<any, any, IId, any>;
}

const useMutateConfigurationTemplateDelete = ({
	onSuccess,
}: IPartialOnSuccess): IUseMutateConfigurationTemplateDeleteReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IId>({
		mutationKey: [CONFIGURATION_TEMPLATES_UPDATE_NOTES],
		mutationFn: deleteConfigurationTemplate,
		onSuccess: () => {
			if (onSuccess) {
				onSuccess();
			}

			dispatch(setSnackbar({
				message: responseMessages.deleteTemplate,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([CONFIGURATION_TEMPLATES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		isLoadingDeleteTemplate: isLoading,
		deleteTemplate: mutate,
	};
};

export default useMutateConfigurationTemplateDelete;
